export function getColumnNames(displayedColumns:any): string[] {
  const columnNames:any[] = []
  displayedColumns.forEach((column:any) => {
   columnNames.push(column.property)
 });
 return columnNames
}